// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".map-embed label[data-v-059b4561]{font-size:.875rem;display:block;margin-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
